export class ViscosityControl {
  active: boolean = false;
  viscosity: number = 0;
  mediumProperty: MediumProperty = MediumProperty.Viscous;
}

export enum MediumProperty {
  Viscous = 0,
  Slurry = 1,
}
